/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { useTranslation } from 'react-i18next';
 
import styles from '../styles/logotext.module.scss'

//import {ReactComponent as LogoWhite}  from '../icons/10_micro_box_no_type_white_pos.svg'
//import {ReactComponent as LogoBlack}  from '../icons/10_micro_box_no_type_black_pos.svg'

import {ReactComponent as LogoWhite}  from '../icons/L_CI-Confi_mymotion_weiss.svg'
import {ReactComponent as LogoBlack}  from '../icons/L_CI-Confi_mymotion_schwarz.svg'

interface LogoTextProps {
    size?: string;
    center?: boolean;
    black?: boolean;
}

export function LogoText(props: LogoTextProps) {
    const {t} = useTranslation();

    let additionalClass = '';
    if(props.size === 'big') {
        additionalClass = styles.big;
    }  
    if(props.size === 'medium') {
        additionalClass = styles.medium;
    }
    return (
        <div className={`${styles.container} ${additionalClass} ${props.center ? styles.center : ''} ${props.black ? styles.black : ''}`}>
            { props.black && <LogoBlack className={styles.logo}/> }
            { !props.black && <LogoWhite className={styles.logo}/> } 
            <div className={styles.textContainer}>
                {process.env.REACT_APP_STAGING === "true" && <p className={styles.staging}>STAGING</p>}
            </div>
        </div>
    );
};
 